import React from 'react';

const AssignmentMarking = ({ data }) => {
  return <div>Assignment Marking</div>;
};

export default AssignmentMarking;
